import { default as React, useState, useEffect, useReducer } from 'react';
import { Typer } from 'react-typetool';

export const Playground = ({ children }) => {
  const [text, setText] = useState('Example');
  // const [startStep, setStartStep] = useState(0);
  const [stepIntervalMS, setStepIntervalMS] = useState(200);
  const [replay, setReplay] = useState(false);
  const [blink, setBlink] = useState(true);
  const [blinkIntervalMS, setBlinkIntervalMS] = useState(500);
  const [showCaret, setShowCaret] = useState(true);
  const [loop, setLoop] = useState(false);
  const [loopIntervalMS, setLoopIntervalMS] = useState(2000);

  const replayHandler = () => {
    setReplay(true);
  };

  const onStart = () => {
    setReplay(false);
  };

  const styleRef = (ref) => {
    ref.current.style.height = '40px';
    // ref.current.style.width = '4px';
    ref.current.style.marginBottom = '2px';
    ref.current.style.backgroundColor = '#ffffff';
  }

  useEffect(() => {
    if (!loop) return;
    replayHandler();
  }, [loop])

  return (
    <div className='playground'>
      <div className='playground__preview'>
        <Typer
          text={text}
          classes="playground__typer"
          replay={replay}
          onStart={onStart}
          useDefaultStyle={false}
          stepIntervalMS={stepIntervalMS}
          // startStep={startStep}
          blink={blink}
          blinkIntervalMS={blinkIntervalMS}
          showCaret={showCaret}
          loop={loop}
          loopIntervalMS={loopIntervalMS}
          getCaretRef={styleRef}
        />
      </div>

      <div className='playground__variables'>
        <div className='input__container'>
          <label className='input__label' htmlFor='inputText'>
            Text
          </label>
          <input
            className='input__field'
            type='text'
            name='inputText'
            id='inputText'
            defaultValue={text}
            onChange={(e) => setText(e.target.value)}
          />
        </div>

        <div className='input__container'>
          <label className='input__label' htmlFor='inputStepIntervalMS'>
            StepIntervalMS
          </label>
          <input
            className='input__field'
            type='number'
            name='inputStepIntervalMS'
            id='inputStepIntervalMS'
            defaultValue={stepIntervalMS}
            onChange={(e) => setStepIntervalMS(e.target.value)}
          />
        </div>
        {/* 
        <div className='input__container'>
          <label className='input__label' htmlFor='inputStartStep'>startStep</label>
          <input
          className='input__field'
          type='number'
          name='inputStartStep'
          id='inputStartStep'
          defaultValue={startStep}
          onChange={(e) => setStartStep(e.target.value)}
          />
        </div> */}

        <div className='input__container'>
          <label className='input__label' htmlFor='inputBlink'>
            Blink
          </label>
          <input
            className='input__checkbox'
            type='checkbox'
            name='inputBlink'
            id='inputBlink'
            defaultChecked={blink}
            onChange={(e) => setBlink(e.target.checked)}
          />
        </div>

        <div className='input__container'>
          <label className='input__label' htmlFor='inputBlinkIntervalMS'>
            BlinkIntervalMS
          </label>
          <input
            className='input__field'
            type='number'
            name='inputBlinkIntervalMS'
            id='inputBlinkIntervalMS'
            defaultValue={blinkIntervalMS}
            onChange={(e) => setBlinkIntervalMS(e.target.value)}
          />
        </div>

        <div className='input__container'>
          <label className='input__label' htmlFor='inputShowCaret'>
            ShowCaret
          </label>
          <input
            className='input__checkbox'
            type='checkbox'
            name='inputShowCaret'
            id='inputShowCaret'
            defaultChecked={showCaret}
            onChange={(e) => setShowCaret(e.target.checked)}
          />
        </div>

        <div className='input__container'>
          <label className='input__label' htmlFor='inputLoop'>
            Loop
          </label>
          <input
            className='input__checkbox'
            type='checkbox'
            name='inputLoop'
            id='inputLoop'
            defaultChecked={loop}
            onChange={(e) => setLoop(e.target.checked)}
          />
        </div>

        <div className='input__container'>
          <label className='input__label' htmlFor='inputLoopIntervalMS'>
            LoopIntervalMS
          </label>
          <input
            className='input__field'
            type='number'
            name='inputLoopIntervalMS'
            id='inputLoopIntervalMS'
            defaultValue={loopIntervalMS}
            onChange={(e) => setLoopIntervalMS(e.target.value)}
          />
        </div>

        <button onClick={replayHandler}>Replay</button>
      </div>
    </div>
  );
};
